import { Stack } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';

export function EmptyState() {
	return (
		<Stack h="100%" spacing="md" align="center" justify="center">
			<Icon name="sparkles" size="lg" color="icon/ai/default" />
			<Stack spacing="xs" align="center">
				<Text size="md" weight="semibold" align="center">
					Generate a preview to validate your AI output
				</Text>
				<Text size="sm" color="text/secondary/default" align="center">
					Select resources and click &quot;Generate preview&quot; to see
					<br />
					what the AI will generate for your configuration
				</Text>
			</Stack>
		</Stack>
	);
}
